import { group as groupService } from '@services/group';
import i18next from 'i18next';

export const fetchGroupsByStoreIds = async (storeIds, showErrorMessage) => {
  try {
    const groupMappings = await groupService.getGroupsOfStores(storeIds);

    const formattedGroups = groupMappings.reduce((acc, groupMapping) => {
      const groupId = groupMapping?.lnkGroupStoregroupmappingrel?.id;
      const groupName = groupMapping?.lnkGroupStoregroupmappingrel?.name;

      if (!groupId) {
        return acc;
      }

      if (!acc[groupId]) {
        acc[groupId] = {
          groupId,
          storeIds: [],
          name: groupName,
          id: groupMapping.id,
        };
      }

      acc[groupId].storeIds.push(groupMapping.storeId);

      return acc;
    }, {});

    return Object.values(formattedGroups);
  } catch (err) {
    showErrorMessage(i18next.t('HOME.ACTIVITY_REPORT_FETCH_GROUPS_FAILURE'));

    return [];
  }
};
